import { usePublishedData } from "../lib/published-data";
import { useShell } from "../lib/document-route";
import { createFileRoute, notFound } from "@tanstack/react-router";
import contentStyles from "../styles/content.css?url";
import { CollectionPage } from "../components/content/collection-page";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadCollection } from "../server/content";

/** A collection or course (/collections/:slug). */
export const Route = createFileRoute("/collections/$slug")({
  loader: async ({ params }) => {
    const page = await loadCollection({ data: params.slug });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = creatorPageHead(shell, {
      pathname: loaderData.head.canonicalPath,
      title: loaderData.head.title,
      description: loaderData.head.description,
      noindex: loaderData.head.noindex,
      structuredData: loaderData.head.structuredData,
    });
    return withStylesheet(head, contentStyles);
  },
  component: Collection,
});

function Collection() {
  const shell = useShell();
  const path = `/collections/${Route.useParams().slug}`;
  const { data } = usePublishedData(Route.useLoaderData(), shell, path, "page");
  return <CollectionPage page={data} />;
}
